export default __webpack_public_path__ + "static/media/Zel.7679eeee.jpg";